// extracted by mini-css-extract-plugin
export default {"tableWrapper":"TablePlay_tableWrapper__A6Q1U","tableContainer":"TablePlay_tableContainer__6OVTD","openSeat":"TablePlay_openSeat__jgb-e"};